import {
    Directive,
    EventEmitter,
    HostBinding,
    HostListener,
    inject,
    Output,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface FileHandle {
    file: File;
    url: SafeUrl;
}

@Directive({
    selector: '[appDrag]',
    standalone: false
})
export class DragDirective {
    @Output() files: EventEmitter<FileHandle[]> = new EventEmitter();

    @HostBinding('class.drag-over') isDragOver = false;

    private sanitizer: DomSanitizer = inject(DomSanitizer);

    constructor() {}

    @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = true;
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = false;
    }

    @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();

        const allowedExtensions = /(\.zip)$/i; // add params

        this.isDragOver = false;

        const files: FileHandle[] = [];
        for (let i = 0; i < evt.dataTransfer.files.length; i++) {
            const file = evt.dataTransfer.files[i];
            if (allowedExtensions.exec(file.name)) {
                const url = this.sanitizer.bypassSecurityTrustUrl(
                    window.URL.createObjectURL(file)
                );
                files.push({ file, url });
            } else {
                // throw error
            }
        }
        if (files.length === 1) {
            // one file
            this.files.emit(files);
        }
    }
}
